<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="accessLoader" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
@if (user_type=='cdm') {
<div class="card">
	<div class="card-header bg-primary">
		{{pagetitle}}
		<button class="btn btn-sm btn-light float-end" matTooltip="Excel" [matTooltipPosition]="'below'"
			(click)="getInvoiceModuleAlertsExcel($event)">
			@if (masterDataExcelLoader) {
			<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
			}@else {
			<fa-icon [icon]="['fas', 'cloud-download-alt']"></fa-icon>
			}
		</button>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-2">
				<ng-select appearance="outline" appendTo="body" [items]="yearList" bindLabel="name" bindValue="value"
					[clearable]="false" [multiple]="false" [(ngModel)]="cardsFilter.year" placeholder="Year"
					(change)="filterChanged();">
				</ng-select>
			</div>
			<div class="col-3">
				<mat-radio-group [(ngModel)]="cardsFilter.subscription_status" (change)="filterChanged();">
					<mat-radio-button [value]="'Subscribed'" [color]="'primary'">
						Subscribed
					</mat-radio-button>
					<mat-radio-button [value]="'Adhoc'" [color]="'primary'">
						Adhoc
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="col-7">
				<ng-select appearance="outline" appendTo="body" [items]="companyList_dropdown" bindLabel="name"
					[clearable]="true" [multiple]="false" [(ngModel)]="cardsFilter.company_id" placeholder="Company"
					(change)="filterChanged();setCompany(cardsFilter.company_id);">
				</ng-select>
			</div>
			<!-- <div class="col-1">
				<button type="button" class="btn btn-md btn-success mt-2 radius-50" (click)="filterChanged();">
					<fa-icon [icon]="['fas', 'search']"></fa-icon>
				</button>
			</div> -->
		</div>
		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="col-sm-12">
						@if (loadingMasterData) {
						<p class="text-center text-bold">
							<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							Loading...
						</p>
						}@else {
						<div class="table-responsive" style="height: 450px;overflow-y: auto;">
							@if (masterData.length) {
							<table class="myTable table table-bordered table-hover mt-2">
								<thead>
									<tr>
										<th style="width: 20% !important;">Vessel Name</th>
										<th style="width: 20% !important;">Company</th>
										<th style="width: 12% !important;">Certificate Validity Date</th>
										<th style="width: 12% !important;">Last Reviewed Date</th>
										<th style="width: 12% !important;">Replenishment 1 Date</th>
										<th style="width: 12% !important;">Replenishment 2 Date</th>
										<th style="width: 12% !important;">Replenishment 3 Date</th>
									</tr>
								</thead>
								<tbody>
									<tr class="table_td_style" *ngFor="let a of masterData;let i = index;">
										<td>{{a.vessel_name}}</td>
										<td>{{a.company_name}}</td>
										<td>{{a.mcc_exp_date}}</td>
										<td>{{a.inv_rev_date}}</td>
										<td>{{a.invoice_date1}}</td>
										<td>{{a.invoice_date2}}</td>
										<td>{{a.invoice_date3}}</td>
									</tr>
								</tbody>
							</table>
							}@else {
							<p class="text-center">
								No data found!
							</p>
							}
						</div>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
}@else {
<h3 class="text-center">You don't have access to this section.</h3>
}